/*
 * UILanguage Messages
 *
 * This contains all the text for the Settings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  selectYourLanguage: {
    id: 'app.containers.UILanguage.selectYourLanguage',
    defaultMessage: 'Select your language',
  },
});
